/** @format */

export enum DPV_CODE {
  DISTINCT_FORM_FIELD_ERROR = -1,
  NO_DPV = 0,
  PERFECT_ADDRESS = 1,
  INVALID_ADDRESS = 2,
  INVALID_APT_NUMBER = 3,
  MISSING_APT_NUMBER = 4,
}
